import config from '../config/config'

const { apiURL } = config
const urlConstant = {
  Account: {
    Login: `${apiURL}api/Account/Login`,
    Logout: `${apiURL}api/Account/Logout`,
    ChangePassword: `${apiURL}api/Account/ChangePassword`,
  },
  UserProfile: {
    upload: `${apiURL}api/Users/ProfilePicUpload`,
    Download: `${apiURL}api/Users/GetProfilePic`,
  },

  Department: {
    DepartmentList: `${apiURL}api/Department/DepartmentList`,
    CreateDepartment: `${apiURL}api/Department/Create`,
    EditDepartment: `${apiURL}api/Department/Edit`,
    DeleteDepartment: `${apiURL}api/Department/Delete`,
    Departmentbyid: `${apiURL}api/Department/GetDepartmentById`,
  },
  Country: {
    CountryList: `${apiURL}api/Country/CountryList`,
    CreateCountry: `${apiURL}api/Country/Create`,
    GetCountryByID: `${apiURL}api/Country/GetCountryById`,
    EditCountry: `${apiURL}api/Country/Edit`,
    GetFlagImage: `${apiURL}api/Country/GetCountryFlagImage`,
    DeleteCountry: `${apiURL}api/Country/Delete`,
  },
  Common: {
    LanguageList: `${apiURL}api/Common/GetLanguageDropDownList`,
    ShippingMethodList: `${apiURL}api/Common/GetShippingMethodDropDownList`,
    GetCoutryDropDownList: `${apiURL}api/Common/GetCoutryDropDownList`,
    GetItemTypesDropDownList: `${apiURL}api/Common/GetItemTypesDropDownList`,
    GetItemCategoryDropDownList: `${apiURL}api/Common/GetItemCategoryDropDownList`,
    GetCustomerTypeDropDownList: `${apiURL}api/Common/GetCustomerTypesDropDownList`,
    GetRankDropDownList: `${apiURL}api/Common/GetRankDropDownList`,
    GetCurrencyDropDownList: `${apiURL}api/Common/GetCurrencyDropDownList`,
    GetEmailServiceTypeList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=EmailServiceType`,
    GetLegalDocumentTypeList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=LegalDocumentType`,
    GetExpirationUnit: `${apiURL}api/Common/GetSupportDataByDataType?DataType=ExpirationUnit`,
    GetRoleList: `${apiURL}api/Common/GetRoleDropDownList`,
    GetInventoryStatusList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=InventoryStatus`,
    GetAvailabilityStatusList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=AvailabilityStatus`,
    GetTokenCreditTypeList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=TokenCreditType`,
    GetBonusTokenTypeList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=BonusTokenType`,
    GetShippingItemTypeList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=ShippingItemType`,
    GetShippingTypeList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=ShippingType`,
    GetAdjustmentTypeList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=AdjustmentType`,
    GetInventoryFileTypeList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=InventoryFileType`,
    GetMediaTypeList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=MediaInformationType`,
    GetMediaPageConfigurationList: `${apiURL}api/Common/GetMediaPageConfigurationDropDownList`,
    GetMediaPageCategoriesList: `${apiURL}api/Common/GetMediaCategoriesDropDownList`,
    GetTimeZoneList: `${apiURL}api/Common/GetTimeZoneDropDownList`,
    GetItemSubTypeList: `${apiURL}api/Common/GetItemSubTypesDropDownList`,
    GetStateList: `${apiURL}api/Common/GetStateDropDownList`,
    GetUserList: `${apiURL}api/Common/GetUserDropDownList`,
    GetPointTypeList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=PointType`,
    GetPointStatusList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=PointStatus`,
    GetItemList: `${apiURL}api/Common/GetItemDropDownList`,
    GetiWalletStatusList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=iWalletStatus`,
    GetCommissionTypeList: `${apiURL}api/Common/GetCommissionTypeDropDownList`,
    GetQualificationList: `${apiURL}api/Common/GetQualificationDropDownList`,
    GetQualificationByItemStatusList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=QualificationByItemStatus`,
    GetAccountType: `${apiURL}api/Common/GetSupportDataByDataType?DataType=eWalletAccountType`,
    GetExternalPaymentApprovalList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=eWalletExternalPaymentApproval`,
    GetAutomatedEmailPeriodList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=AutomatedEmailPeriod`,
    GetAutomatedEmailBeforeAfterList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=AutomatedEmailBeforeAfter`,
    GetMerchantTypeList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=MerchantType`,
    GetFeeTitleList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=FeeTitle`,
    GetUserDropDownList: `${apiURL}api/Common/GetUserDropDownList`,
    GetPaymentMethodList: `${apiURL}api/Common/GetPaymentMethodDropDownList`,
    GetOrderStatusList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=OrderStatus`,
    GetTransactionMerchantType: `${apiURL}api/Common/GetSupportDataByDataType?DataType=TransMerchantType`,
    GetTransactionMerchantAccountType: `${apiURL}api/Common/GetSupportDataByDataType?DataType=TransMerchantAccountType`,
    GetPaymentConfigurationTypeList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=PaymentConfigurationType`,
    GetGiftCardTypeList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=GiftCardType`,
    GetGiftCardStatusList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=GiftCardStatus`,
    GiftCardTransType: `${apiURL}api/Common/GetSupportDataByDataType?DataType=GiftCardTransType`,
    GetEmailTemplateTagList: `${apiURL}api/Common/GetEmailTemplateTagDropDownList`,
    GetItemAttributeConfigurationList: `${apiURL}api/Common/GetItemAttributeConfigurationDropDownList`,
    GetItemListByItemSubType: `${apiURL}api/Common/GetItemListByItemSubType`,
    GetRegistrationTypeList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=EnrollmentRegistrationType`,
    GetAllDropDownList: `${apiURL}api/Common/GetAllDropDownList`,
    GetiWalletTransactionType: `${apiURL}api/Common/GetSupportDataByDataType?DataType=iWalletTransactionType`,
    GetWithdrawMethodList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=WithdrawMethod`,
    GetSupportDataByDataType: `${apiURL}api/Common/GetSupportDataByDataType`,
    GetMembershipARBPaymentMethodList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=SmartShipARB`,
    GetOrderRecalculateCommissionPIN: `${apiURL}api/Common/GetSupportDataByDataType?DataType=PinNumber`,
    GetCreditStatusList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=CreditStatus`,
    GetWireAccountTypeList: `${apiURL}api/Common/GetSupportDataByDataType?DataType=WireAccountType`,
    GetAllDropDownListForSignUp: `${apiURL}api/Common/GetAllDropDownListForSignUp`,
  },
  State: {
    StateList: `${apiURL}api/State/StateList`,
    CreateState: `${apiURL}api/State/Create`,
    GetStateById: `${apiURL}api/State/GetStateById`,
    EditState: `${apiURL}api/State/Edit`,
    DeleteState: `${apiURL}api/State/Delete`,
  },
  QualificationConfiguration: {
    QualificationList: `${apiURL}api/QualificationConfiguration/QualificationList`,
    CreateQualification: `${apiURL}api/QualificationConfiguration/Create`,
    GetQualificationByID: `${apiURL}api/QualificationConfiguration/GetQualificationById`,
    EditQualification: `${apiURL}api/QualificationConfiguration/Edit`,
    DeleteQualification: `${apiURL}api/QualificationConfiguration/Delete`,
  },
  EmailAccountConfiguration: {
    EmailAccountList: `${apiURL}api/EmailAccountConfiguration/EmailAccountConfigurationList`,
    CreateEmailAccount: `${apiURL}api/EmailAccountConfiguration/Create`,
    EditEmailAccount: `${apiURL}api/EmailAccountConfiguration/Edit`,
  },
  Rank: {
    RankList: `${apiURL}api/Rank/RankList`,
    CreateRank: `${apiURL}api/Rank/Create`,
    GetRankByID: `${apiURL}api/Rank/GetRankById`,
    EditRank: `${apiURL}api/Rank/Edit`,
    DeleteRank: `${apiURL}api/Rank/Delete`,
  },
  ShippingMethod: {
    ShippingMethodList: `${apiURL}api/ShippingMethod/ShippingMethodList`,
    CreateShippingMethod: `${apiURL}api/ShippingMethod/Create`,
    GetShippingMethodByID: `${apiURL}api/ShippingMethod/GetShippingMethodById`,
    EditShippingMethod: `${apiURL}api/ShippingMethod/Edit`,
    DeleteShippingMethod: `${apiURL}api/ShippingMethod/Delete`,
  },
  Role: {
    RoleList: `${apiURL}api/Role/RoleList`,
    CreateRole: `${apiURL}api/Role/Create`,
    GetRoleByID: `${apiURL}api/Role/GetRoleById`,
    EditRole: `${apiURL}api/Role/Edit`,
    DeleteRole: `${apiURL}api/Role/Delete`,
  },
  LegalDocument: {
    LegalDocumentList: `${apiURL}api/LegalDocument/LegalDocumentList`,
    CreateLegalDocument: `${apiURL}api/LegalDocument/Create`,
    GetLegalDocumentById: `${apiURL}api/LegalDocument/GetLegalDocumentById`,
    EditLegalDocument: `${apiURL}api/LegalDocument/Edit`,
    DeleteLegalDocument: `${apiURL}api/LegalDocument/Delete`,
  },
  ItemType: {
    ItemTypeList: `${apiURL}api/ItemType/ItemTypeList`,
    CreateItemType: `${apiURL}api/ItemType/Create`,
    GetItemTypeById: `${apiURL}api/ItemType/GetItemTypeById`,
    EditItemType: `${apiURL}api/ItemType/Edit`,
    DeleteItemType: `${apiURL}api/ItemType/Delete`,
  },
  CustomerType: {
    CustomerTypeList: `${apiURL}api/CustomerType/CustomerTypeList`,
    CreateCustomerType: `${apiURL}api/CustomerType/Create`,
    GetCustomerTypeById: `${apiURL}api/CustomerType/GetCustomerTypeById`,
    EditCustomerType: `${apiURL}api/CustomerType/Edit`,
    DeleteCustomerType: `${apiURL}api/CustomerType/Delete`,
  },
  ItemCategory: {
    ItemCategoryList: `${apiURL}api/ItemCategory/ItemCategoryList`,
    CreateItemCategory: `${apiURL}api/ItemCategory/Create`,
    GetItemCategoryById: `${apiURL}api/ItemCategory/GetItemCategoryById`,
    EditItemCategory: `${apiURL}api/ItemCategory/Edit`,
    DeleteItemCategory: `${apiURL}api/ItemCategory/Delete`,
  },
  UserManagement: {
    UserManagementList: `${apiURL}api/User/UserList`,
    CreateUser: `${apiURL}api/User/Create`,
    GetUserById: `${apiURL}api/User/GetUserDetails`,
    EditUser: `${apiURL}api/User/Edit`,
    DeleteUser: `${apiURL}api/User/Delete`,
    EditUserCountryAccessRights: `${apiURL}api/User/EditUserCountryAccessRights`,
    ResetPassword: `${apiURL}api/User/ResetPassword`,
    ChangePassword: `${apiURL}api/User/ChangePassword`,
    CheckReplicationSiteDetails: `${apiURL}api/SignUp/CheckReplicationSiteNameExistence`,
    CheckEmailDetails: `${apiURL}api/SignUp/CheckEmailExistence`,
    Authorization: `${apiURL}api/User/Authorization`,
    GetSponsorSearchUserList: `${apiURL}api/User/GetSponsorSearchUserList`,
    GetSponsorDetailById: `${apiURL}api/User/GetSponsorDetailById`,
    EditUserLoginInfo: `${apiURL}api/User/EditUserLoginInfo`,
    CreateUserFreedomAccount: `${apiURL}api/User/CreateUserFreedomAccount`,
  },
  Currency: {
    CurrencyList: `${apiURL}api/Currency/CurrencyList`,
    CreateCurrency: `${apiURL}api/Currency/Create`,
    GetCurrencyById: `${apiURL}api/Currency/GetCurrencyById`,
    EditCurrency: `${apiURL}api/Currency/Edit`,
    DeleteCurrency: `${apiURL}api/Currency/Delete`,
  },
  Inventory: {
    InventoryList: `${apiURL}api/Inventory/InventoryList`,
    CreateInventory: `${apiURL}api/Inventory/Create`,
    GetInventoryById: `${apiURL}api/Inventory/GetInventoryById`,
    EditInventory: `${apiURL}api/Inventory/Edit`,
    UpdateStatus: `${apiURL}api/Inventory/UpdateStatus`,
  },
  ItemPoint: {
    CreateOrEditItemPoint: `${apiURL}api/ItemPoint/CreateOrEdit`,
    GetItemPointyById: `${apiURL}api/ItemPoint/GetItemPointById`,
  },
  ItemShipping: {
    CreateOrEditItemShipping: `${apiURL}api/ItemShipping/CreateOrEdit`,
    GetItemShippingById: `${apiURL}api/ItemShipping/GetItemShippingById`,
  },
  ItemInventory: {
    CreateOrEditItemInventory: `${apiURL}api/ItemInventoryControl/CreateOrEdit`,
    GetItemInventoryById: `${apiURL}api/ItemInventoryControl/GetItemInventoryById`,
    InventoryAdjustmentList: `${apiURL}api/ItemInventoryControl/ItemStockLedgerList`,
    CreateInventoryAdjustment: `${apiURL}api/ItemInventoryControl/Create`,
  },
  ItemImage: {
    ItemImageList: `${apiURL}api/ItemImage/ItemImageList`,
    CreateItemImage: `${apiURL}api/ItemImage/Create`,
    GetItemImage: `${apiURL}api/ItemImage/GetItemImage`,
    DeleteItemImage: `${apiURL}api/ItemImage/Delete`,
  },
  MediaCategory: {
    MediaCategoryList: `${apiURL}api/MediaCategories/MediaCategoriesList`,
    CreateMediaCategory: `${apiURL}api/MediaCategories/Create`,
    GetMediaCategoryByID: `${apiURL}api/MediaCategories/GetMediaCategoriesById`,
    EditMediaCategory: `${apiURL}api/MediaCategories/Edit`,
    DeleteMediaCategory: `${apiURL}api/MediaCategories/Delete`,
  },
  MediaPageConfiguration: {
    MediaPageConfigurationList: `${apiURL}api/MediaPageConfiguration/MediaPageConfigurationList`,
    CreateMediaPageConfiguration: `${apiURL}api/MediaPageConfiguration/Create`,
    GetMediaPageConfigurationByID: `${apiURL}api/MediaPageConfiguration/GetMediaPageConfigurationById`,
    EditMediaPageConfiguration: `${apiURL}api/MediaPageConfiguration/Edit`,
    DeleteMediaPageConfiguration: `${apiURL}api/MediaPageConfiguration/Delete`,
  },
  MediaPage: {
    MediaPageList: `${apiURL}api/MediaPages/MediaPagesList`,
    CreateMediaPage: `${apiURL}api/MediaPages/Create`,
    GetMediaPageByID: `${apiURL}api/MediaPages/GetMediaPagesById`,
    EditMediaPage: `${apiURL}api/MediaPages/Edit`,
    DeleteMediaPage: `${apiURL}api/MediaPages/Delete`,
  },
  MediaPageDetails: {
    MediaPageDetailsList: `${apiURL}api/MediaPageDetails/MediaPageDetailList`,
    CreateMediaPageDetails: `${apiURL}api/MediaPageDetails/Create`,
    GetMediaPageDetailsByID: `${apiURL}api/MediaPageDetails/GetMediaPageDetailsById`,
    EditMediaPageDetails: `${apiURL}api/MediaPageDetails/Edit`,
    DeleteMediaPageDetails: `${apiURL}api/MediaPageDetails/Delete`,
    GetMediaByID: `${apiURL}api/MediaPageDetails/GetMedia`,
  },
  PaymentMethod: {
    PaymentMethodList: `${apiURL}api/PaymentMethod/PaymentMethodList`,
    CreatePaymentMethod: `${apiURL}api/PaymentMethod/Create`,
    GetPaymentMethodById: `${apiURL}api/PaymentMethod/GetPaymentMethodById`,
    EditPaymentMethod: `${apiURL}api/PaymentMethod/Edit`,
    DeletePaymentMethod: `${apiURL}api/PaymentMethod/Delete`,
  },
  ErrorLog: {
    AddErrorLog: `${apiURL}api/UIErrorLog/Create`,
  },
  Order: {
    OrderList: `${apiURL}api/Order/OrderList`,
    OrderCreate: `${apiURL}api/Order/Create`,
    OrderDetails: `${apiURL}api/Order/GetOrderById`,
    OrderEdit: `${apiURL}api/Order/Edit`,
    OrderDelete: `${apiURL}api/Order/Delete`,
    OrderCancelled: `${apiURL}api/Order/OrderCancel`,
    OrderRefund: `${apiURL}api/Order/OrderRefund`,
    OrderRecalculateCommission: `${apiURL}api/Order/OrderRecalculateCommission`,
    OrderAccountChange: `${apiURL}api/Order/OrderAccountChange`,
    UpdateItemQuantity: `${apiURL}api/Order/UpdateItemQuantity`,
    ExistingCardList: `${apiURL}api/PaymentProfile/GetExistingCardListByUserId`,
    GetShippingInfo: `${apiURL}api/Order/GetShippingInfoByOrderId`,
    ResendInvoice: `${apiURL}api/Order/ResendInvoice`,
    SendOrderToShipStation: `${apiURL}api/Order/SendOrderToShipStation`,
  },
  Point: {
    PointList: `${apiURL}api/Point/PointList`,
    CreatePoint: `${apiURL}api/Point/Create`,
    GetPointById: `${apiURL}api/Point/GetPointById`,
    EditPoint: `${apiURL}api/Point/Edit`,
    DeletePoint: `${apiURL}api/Point/Delete`,
    GetPointSummary: `${apiURL}api/Point/GetPointSummary`,
  },
  CommissionType: {
    CommissionTypeList: `${apiURL}api/CommissionType/CommissionTypeList`,
    CreateCommissionType: `${apiURL}api/CommissionType/Create`,
    GetCommissionTypeById: `${apiURL}api/CommissionType/GetCommissionTypeById`,
    EditCommissionType: `${apiURL}api/CommissionType/Edit`,
    DeleteCommissionType: `${apiURL}api/CommissionType/Delete`,
  },
  iWallet: {
    iWalletList: `${apiURL}api/iWallet/iWalletList`,
    CreateiWallet: `${apiURL}api/iWallet/Create`,
    GetiWalletById: `${apiURL}api/iWallet/GetiWalletById`,
    EditiWallet: `${apiURL}api/iWallet/Edit`,
    iWalletUpdateStatus: `${apiURL}api/iWallet/UpdateStatus`,
    GetiWalletSummary: `${apiURL}api/iWallet/GetiWalletSummaryId`,
    iWalletUpdatePedingToActive: `${apiURL}api/iWallet/UpdateiWalletStatusPendingToActive`,
  },
  QualificationByItem: {
    QualificationByItemList: `${apiURL}api/QualificationByItem/QualificationByItemList`,
    CreateQualificationByItem: `${apiURL}api/QualificationByItem/Create`,
    GetQualificationByItemById: `${apiURL}api/QualificationByItem/GetQualificationByItemById`,
    EditQualificationByItem: `${apiURL}api/QualificationByItem/Edit`,
    DeleteQualificationByItem: `${apiURL}api/QualificationByItem/Delete`,
  },
  FeeConfiguration: {
    FeeConfigurationList: `${apiURL}api/FeeConfiguration/FeeConfigurationList`,
    CreateFeeConfiguration: `${apiURL}api/FeeConfiguration/Create`,
    GetFeeConfigurationById: `${apiURL}api/FeeConfiguration/GetFeeConfigurationById`,
    EditFeeConfiguration: `${apiURL}api/FeeConfiguration/Edit`,
    DeleteFeeConfiguration: `${apiURL}api/FeeConfiguration/Delete`,
  },
  TransactionMerchant: {
    TransactionMerchantList: `${apiURL}api/TransactionMerchant/TransactionMerchantList`,
    CreateTransactionMerchant: `${apiURL}api/TransactionMerchant/Create`,
    GetTransactionMerchantById: `${apiURL}api/TransactionMerchant/GetTransactionMerchantById`,
    EditTransactionMerchant: `${apiURL}api/TransactionMerchant/Edit`,
    DeleteTransactionMerchant: `${apiURL}api/TransactionMerchant/Delete`,
  },
  eWalletConfiguration: {
    eWalletConfigurationList: `${apiURL}api/eWalletConfiguration/eWalletConfigurationList`,
    CreateeWalletConfiguration: `${apiURL}api/eWalletConfiguration/Create`,
    GeteWalletConfigurationById: `${apiURL}api/eWalletConfiguration/GeteWalletConfigurationById`,
    EditeWalletConfiguration: `${apiURL}api/eWalletConfiguration/Edit`,
    DeleteeWalletConfiguration: `${apiURL}api/eWalletConfiguration/Delete`,
  },
  ExternalPaymentConfiguration: {
    ExternalPaymentConfigurationList: `${apiURL}api/ExternalPaymentConfiguration/ExternalPaymentConfigurationList`,
    CreateExternalPaymentConfiguration: `${apiURL}api/ExternalPaymentConfiguration/Create`,
    GetExternalPaymentConfigurationById: `${apiURL}api/ExternalPaymentConfiguration/GetExternalPaymentConfigurationById`,
    EditExternalPaymentConfiguration: `${apiURL}api/ExternalPaymentConfiguration/Edit`,
    DeleteExternalPaymentConfiguration: `${apiURL}api/ExternalPaymentConfiguration/Delete`,
  },
  GiftCard: {
    GiftCardList: `${apiURL}api/GiftCard/GiftCardList`,
    CreateGiftCard: `${apiURL}api/GiftCard/Create`,
    GetGiftCardByID: `${apiURL}api/GiftCard/GetGiftCardById`,
    EditGiftCard: `${apiURL}api/GiftCard/Edit`,
    DeleteGiftCard: `${apiURL}api/GiftCard/Delete`,
    GetGiftCardCode: `${apiURL}api/GiftCard/GetGiftCardCode`,
    GetGiftCardSummary: `${apiURL}api/GiftCard/GetGiftCardSummaryId`,
  },
  GiftCardLedger: {
    GiftCardAdjustmentList: `${apiURL}api/GiftCardLedger/GiftCardLedgerList`,
    CreateGiftCardAdjustment: `${apiURL}api/GiftCardLedger/Create`,
  },
  EmailTemplate: {
    EmailTemplateList: `${apiURL}api/EmailTemplate/EmailTemplateList`,
    CreateEmailTemplate: `${apiURL}api/EmailTemplate/Create`,
    GetEmailTemplateById: `${apiURL}api/EmailTemplate/GetEmailTemplateDetailsById`,
    EditEmailTemplate: `${apiURL}api/EmailTemplate/Edit`,
    DeleteEmailTemplate: `${apiURL}api/EmailTemplate/Delete`,
    SendEmailById: `${apiURL}api/EmailTemplate/SendEmailById`,
  },
  EmailTemplateConfiguration: {
    EmailTemplateList: `${apiURL}api/EmailTemplateConfiguration/EmailTemplateList`,
    CreateEmailTemplate: `${apiURL}api/EmailTemplateConfiguration/Create`,
    GetEmailTemplateById: `${apiURL}api/EmailTemplateConfiguration/GetEmailTemplateDetailsById`,
    EditEmailTemplate: `${apiURL}api/EmailTemplateConfiguration/Edit`,
    DeleteEmailTemplate: `${apiURL}api/EmailTemplateConfiguration/Delete`,
  },
  Template: {
    TemplateList: `${apiURL}api/Template/TemplateList`,
    CreateTemplate: `${apiURL}api/Template/Create`,
    GetTemplateById: `${apiURL}api/Template/GetTemplateDetailsById`,
    EditTemplate: `${apiURL}api/Template/Edit`,
    DeleteTemplate: `${apiURL}api/Template/Delete`,
  },
  ItemAttributeConfiguration: {
    ItemAttributeConfigurationList: `${apiURL}api/ItemAttributeConfiguration/ItemAttributeConfigurationList`,
    CreateItemItemAttributeConfiguartion: `${apiURL}api/ItemAttributeConfiguration/Create`,
    GetItemAttributeConfiguartionById: `${apiURL}api/ItemAttributeConfiguration/GetItemAttributeConfigurationById`,
    EditItemAttributeConfiguartion: `${apiURL}api/ItemAttributeConfiguration/Edit`,
    DeleteItemAttributeConfiguartion: `${apiURL}api/ItemAttributeConfiguration/Delete`,
  },
  ItemAttribute: {
    ItemAttributeList: `${apiURL}api/ItemAttribute/ItemAttributeList`,
    CreateItemItemAttribute: `${apiURL}api/ItemAttribute/Create`,
    GetItemAttributeById: `${apiURL}api/ItemAttribute/GetItemAttributeById`,
    EditItemAttribute: `${apiURL}api/ItemAttribute/Edit`,
    DeleteItemAttribute: `${apiURL}api/ItemAttribute/Delete`,
  },
  ReoccurringBilling: {
    ReoccurringBillingList: `${apiURL}api/ItemReoccurring/ItemReoccurringList`,
    CreateReoccurringBilling: `${apiURL}api/ItemReoccurring/Create`,
    GetReoccurringBillingById: `${apiURL}api/ItemReoccurring/GetItemReoccurringById`,
    EditReoccurringBilling: `${apiURL}api/ItemReoccurring/Edit`,
    DeleteReoccurringBilling: `${apiURL}api/ItemReoccurring/Delete`,
  },
  PromoEvent: {
    GetPromoEventTypeDropDownList: `${apiURL}api/PromoEvent/GetPromoEventTypeDropDownList`,
    GetPromoEventTypeById: `${apiURL}api/PromoEvent/GetPromoEventTypeById`,
    PromoEventList: `${apiURL}api/PromoEvent/PromoEventList`,
    DeletePromoEvent: `${apiURL}api/PromoEvent/Delete`,
    CreatePromoEvent: `${apiURL}api/PromoEvent/Create`,
    EditPromoEvent: `${apiURL}api/PromoEvent/Edit`,
    PromEventDetails: `${apiURL}api/PromoEvent/GetPromoEventById`,
  },
  PromoAction: {
    GetPromoActionTypeDropDownList: `${apiURL}api/PromoAction/GetPromoActionTypeDropDownList`,
    GetPromoActionTypeById: `${apiURL}api/PromoAction/GetPromoActionTypeById`,
    PromoActionList: `${apiURL}api/PromoAction/PromoActionList`,
    DeletePromoAction: `${apiURL}api/PromoAction/Delete`,
    PromActionDetails: `${apiURL}api/PromoAction/GetPromoActionById`,
    CreatePromoAction: `${apiURL}api/PromoAction/Create`,
    EditPromoAction: `${apiURL}api/PromoAction/Edit`,
  },
  Promotion: {
    PromotionList: `${apiURL}api/Promotion/PromotionList`,
    CreatePromotion: `${apiURL}api/Promotion/Create`,
    EditPromotion: `${apiURL}api/Promotion/Edit`,
    GetPromotionById: `${apiURL}api/Promotion/GetPromotionById`,
    DeletePromotion: `${apiURL}api/Promotion/Delete`,
  },
  Customer: {
    GetCustomerById: `${apiURL}api/Customer/GetCustomerDetails`,
    iWalletList: `${apiURL}api/iWallet/iWalletListByUserID`,
    PointList: `${apiURL}api/Point/PointListByUserID`,
    ItemList: `${apiURL}api/Order/UserOrderedItemListByUserID`,
    MembershipInvoiceList: `${apiURL}api/SmartshipInvoice/SmartshipInvoiceListByUserId`,
    QualificationList: `${apiURL}api/UserQualification/UserQualificationListByUserId`,
    GetSponsorTreeList: `${apiURL}api/ReferralTree/SponsorListByUserID`,
    GetSponsorTreeUplineList: `${apiURL}api/ReferralTree/SponsoreTreeUplineListByUserID`,
    GetiWalletSummary: `${apiURL}api/iWallet/GetiWalletSummaryByUserId`,
    PlacementTree: `${apiURL}api/BinaryPlacementTree/PlacementTreeListByUserID`,
    CheckAccountIdInPlacementTree: `${apiURL}api/BinaryPlacementTree/CheckAccountIdForPlacementTree`,
    EmailList: `${apiURL}api/EmailSentLog/EmailSentLogListByUserId`,
    ResendEmail: `${apiURL}api/EmailTemplate/SendEmailById`,
    PersonallySponsoredList: `${apiURL}api/ReferralTree/PersonallySponsoredListByUserID`,
    RemoveTaxId: `${apiURL}api/Customer/RemoveTaxId`,
    SendResetEmail: `${apiURL}api/User/SendResetPasswordEmail`,
  },
  MembershipInvoice: {
    MembershipInvoiceList: `${apiURL}api/SmartshipInvoice/SmartshipInvoiceList`,
    CreateMembershipInvoice: `${apiURL}api/SmartshipInvoice/Create`,
    MembershipInvoiceByID: `${apiURL}api/SmartshipInvoice/GetSmartshipInvoiceByID`,
    EditMembershipInvoice: `${apiURL}api/SmartshipInvoice/Edit`,
    MembershipInvoiceStatusUpdate: `${apiURL}api/SmartshipInvoice/StatusUpdate`,
    RunAllMembershipInvoices: `${apiURL}api/SmartshipInvoice/RunAllSmartshipInvoices`,
    RunMembershipInvoiceById: `${apiURL}api/SmartshipInvoice/RunSmartshipInvoiceByID`,
    GetMembershipInvoiceFailureListByInvoiceID: `${apiURL}api/SmartshipInvoice/GetSmartshipInvoiceFailureListByInvoiceID`,
    GetInvoiceProcessingLog: `${apiURL}api/SmartshipInvoiceLog/GetInvoiceProcessingLog`,
    GetInvoiceProcessingLogSummary: `${apiURL}api/SmartshipInvoiceLog/GetInvoiceProcessingLogSummary`,
  },
  Menu: {
    MenuList: `${apiURL}api/AdminMenu/List`,
  },
  BinaryTreeError: {
    BinaryTreeErrorList: `${apiURL}api/BinaryTreeError/List`,
  },
  iWalletWithdrawal: {
    iWalletWithdrawalUpdateStatus: `${apiURL}api/iWalletWithdrawal/UpdateStatus`,
    iWalletWithdrawalList: `${apiURL}api/iWalletWithdrawal/iWalletWithdrawalList`,
    RunCommissionWithdraw: `${apiURL}api/iWalletWithdrawal/RunCommissionWithdraw`,
  },
  ItemIngredient: {
    ItemIngredientList: `${apiURL}api/ItemIngredient/ItemIngredientList`,
    CreateItemIngredient: `${apiURL}api/ItemIngredient/Create`,
    GetItemIngredientById: `${apiURL}api/ItemIngredient/GetItemIngredientById`,
    EditItemIngredient: `${apiURL}api/ItemIngredient/Edit`,
    DeleteItemIngredient: `${apiURL}api/ItemIngredient/Delete`,
  },
  ItemFeature: {
    ItemFeatureList: `${apiURL}api/ItemFeature/ItemFeatureList`,
    CreateItemFeature: `${apiURL}api/ItemFeature/Create`,
    GetItemFeatureById: `${apiURL}api/ItemFeature/GetItemFeatureById`,
    EditItemFeature: `${apiURL}api/ItemFeature/Edit`,
    DeleteItemFeature: `${apiURL}api/ItemFeature/Delete`,
  },
  UserQualification: {
    GetUserQualificationById: `${apiURL}api/UserQualification/GetUserQualificationById`,
    CreateUserQualification: `${apiURL}api/UserQualification/Create`,
    EditUserQualification: `${apiURL}api/UserQualification/Edit`,
    UserLocationList: `${apiURL}api/UserLocation/UserLocationList`,
  },
  AdminNote: {
    GetUserAdminNoteById: `${apiURL}api/AdminNote/GetAdminNoteById`,
    CreateUserAdminNote: `${apiURL}api/AdminNote/Create`,
    EditUserAdminNote: `${apiURL}api/AdminNote/Edit`,
    AdminNoteList: `${apiURL}api/AdminNote/AdminNoteListByUserId`,
  },
  Language: {
    LanguageList: `${apiURL}api/Language/LanguageList`,
    CreateLanguage: `${apiURL}api/Language/Create`,
    GetLanguageById: `${apiURL}api/Language/GetLanguageById`,
    EditLanguage: `${apiURL}api/Language/Edit`,
    DeleteLanguage: `${apiURL}api/Language/Delete`,
  },
  UniLevelCommission: {
    UniLevelCommissionList: `${apiURL}api/UniLevelCommission/UniLevelCommissionList`,
    GetUniLevelCommissionById: `${apiURL}api/UniLevelCommission/GetUniLevelCommissionById`,
    EditUniLevelCommission: `${apiURL}api/UniLevelCommission/Edit`,
    UniLevelCommissionSync: `${apiURL}api/UniLevelCommission/GetUniLevelCommissionSync`,
  },
  InfluencerRegistrationUrl: {
    InfluencerRegistrationUrlList: `${apiURL}api/InfluencerRegistrationUrl/List`,
    InfluencerRegistrationUrlCreate: `${apiURL}api/InfluencerRegistrationUrl/Create`,
    InfluencerRegistrationUrlById: `${apiURL}api/InfluencerRegistrationUrl/GetById`,
    InfluencerRegistrationUrlEdit: `${apiURL}api/InfluencerRegistrationUrl/Edit`,
    InfluencerRegistrationUrlDelete: `${apiURL}api/InfluencerRegistrationUrl/Delete`,
  },
  BackOfficeMenu: {
    GetBackOfficeMenuList: `${apiURL}api/BackOfficeMenu/GetBackOfficeMenuList`,
    CreateBackOfficeMenu: `${apiURL}api/BackOfficeMenu/Create`,
    GetBackOfficeMenuById: `${apiURL}api/BackOfficeMenu/GetBackOfficeMenuById`,
    EditBackOfficeMenu: `${apiURL}api/BackOfficeMenu/Edit`,
    DeleteBackOfficeMenu: `${apiURL}api/BackOfficeMenu/Delete`,
  },
  AdminMenu: {
    getAdminMenuList: `${apiURL}api/AdminMenu/GetAdminMenuList`,
    createAdminMenu: `${apiURL}api/AdminMenu/Create`,
    getAdminMenuById: `${apiURL}api/AdminMenu/GetAdminMenuById`,
    editAdminMenu: `${apiURL}api/AdminMenu/Edit`,
    deleteAdminMenu: `${apiURL}api/AdminMenu/Delete`,
  },
  MembershipARBConfiguration: {
    MembershipARBConfigurationDetails: `${apiURL}api/SmartshipARBConfiguration/GetSmartshipARBConfigurationDetails`,
    CreateMembershipARBConfiguration: `${apiURL}api/SmartshipARBConfiguration/Create`,
    EditMembershipARBConfiguration: `${apiURL}api/SmartshipARBConfiguration/Edit`,
  },
  RestrictedSubDomain: {
    RestrictedSubDomainList: `${apiURL}api/RestrictedSubDomain/RestrictedSubDomainList`,
    CreateRestrictedSubDomain: `${apiURL}api/RestrictedSubDomain/Create`,
    GetRestrictedSubDomainById: `${apiURL}api/RestrictedSubDomain/GetRestrictedSubDomainById`,
    EditRestrictedSubDomain: `${apiURL}api/RestrictedSubDomain/Edit`,
    DeleteRestrictedSubDomain: `${apiURL}api/RestrictedSubDomain/Delete`,
  },
  Credit: {
    GetCreditSummary: `${apiURL}api/Credit/GetCreditSummaryById`,
    CreditList: `${apiURL}api/Credit/CreditList`,
    GetProductCreditById: `${apiURL}api/Credit/GetCreditById`,
    CreateProductCredit: `${apiURL}api/Credit/Create`,
    EditProductCredit: `${apiURL}api/Credit/Edit`,
    ProductCreditUpdateStatus: `${apiURL}api/Credit/UpdateStatus`,
  },
  Report: {
    SalesByItemReport: `${apiURL}api/Reports/SalesByItemReport`,
    SalesByOrderReport: `${apiURL}api/Reports/SalesByOrderReport`,
    SalesByTopAffiliate: `${apiURL}api/Reports/SalesByTopAffiliateReport`,
    SalesByTopItemValueReport: `${apiURL}api/Reports/SalesByTopItemValue`,
    SalesByTopItemQtyReport: `${apiURL}api/Reports/SalesByTopItemQty`,
    CommissionEarnedByPeriodsReport: `${apiURL}api/Reports/CommissionEarnedByPeriodsReport`,
    CommissionPaidOutByPeriodsReport: `${apiURL}api/Reports/CommissionPaidOutByPeriodsReport`,
    IWalletSummaryReport: `${apiURL}api/Reports/iWalletSummaryReport`,
    iWalletWithdrawMethodReport: `${apiURL}api/Reports/iWalletWithdrawMethodReport`,
    iWalletWithdrawMethodDelete: `${apiURL}api/Reports/Delete`,
    ChangePayOutsStatus: `${apiURL}api/Reports/ChangePayOutsStatus`,
    iWallet1099Report: `${apiURL}api/Reports/iWallet1099Report`,
    GetiWalletWithdrawMethodById: `${apiURL}api/Reports/GetiWalletWithdrawMethodById`,
    iWalletWithdrawMethodEdit: `${apiURL}api/Reports/Edit`,
    SalesByCountryReport: `${apiURL}api/Reports/SalesByCountryReport`,
  },
  AdminDashboard: {
    GetRecentOrders: `${apiURL}api/AdminDashboard/GetRecentOrders`,
    GetDailySales: `${apiURL}api/AdminDashboard/GetDailySales`,
    GetMonthlySales: `${apiURL}api/AdminDashboard/GetMonthlySales`,
    GetTopAffiliateSalesMonthToDate: `${apiURL}api/AdminDashboard/GetTopAffiliateSalesMonthToDate`,
  },
  DirectCommissionConfiguration: {
    GetDirectCommissionConfigurationDetails: `${apiURL}api/DirectCommissionConfiguration/GetDirectCommissionConfigurationDetails`,
    CreateDirectCommissionConfiguration: `${apiURL}api/DirectCommissionConfiguration/Create`,
    EditDirectCommissionConfiguration: `${apiURL}api/DirectCommissionConfiguration/Edit`,
  },
  SeamlessLogin: {
    SeamlessLoginCreate: `${apiURL}api/SeamlessLogin/Create`,
    SeamlessLoginConsume: `${apiURL}api/SeamlessLogin/Consume`,
  },
  AutomatedEmail: {
    AutomatedEmailList: `${apiURL}api/AutomatedEmail/AutomatedEmailList`,
    AutomatedEmailEdit: `${apiURL}api/AutomatedEmail/Edit`,
    AutomatedEmailCreate: `${apiURL}api/AutomatedEmail/Create`,
    GetAutomatedEmailById: `${apiURL}api/AutomatedEmail/GetAutomatedEmailDetailsById`,
    GetTemplateById: `${apiURL}api/Template/GetTemplateDetailsById`,
    EditTemplate: `${apiURL}api/Template/Edit`,
    DeleteTemplate: `${apiURL}api/Template/Delete`,
    SendTestEmail: `${apiURL}api/AutomatedEmail/SendTestEmail`,
  },
  LeadCollection: {
    UploadLeadCollectionFreedomCommission: `${apiURL}api/LeadCollection/UploadLeadCollectionFreedomCommission`,
    UploadLeadCollectionADPCommission: `${apiURL}api/LeadCollection/UploadLeadCollectionADPCommission`,
    LeadFreedomCommissionList: `${apiURL}api/LeadCollection/LeadCollectionFreedomCommissionList`,
    LeadCollectionADPCommissionList: `${apiURL}api/LeadCollection/LeadCollectionADPCommissionList`,
    GetAllLeadCollectionList: `${apiURL}api/LeadCollection/GetAllLeadCollectionList`,
    UpdateLeadDetailByAdmin: `${apiURL}api/LeadCollection/UpdateLeadDetailByAdmin`,
  },
  StoreProcedureHistory: {
    ExecuteTeamBuildingRankAssignment: `${apiURL}api/StoreProcedureHistory/ExecuteTeamBuildingRankAssignment`,
    GetStoredProcedureHistoryByName: `${apiURL}api/StoreProcedureHistory/GetStoredProcedureHistoryByName`,
    GetDualTeamBonusCommissionListByStartEndDateGroup: `${apiURL}api/StoreProcedureHistory/GetDualTeamBonusCommissionListByStartEndDateGroup`,
    GetDualTeamBonusCommissionListByStartEndDateForExcel: `${apiURL}api/StoreProcedureHistory/GetDualTeamBonusCommissionListByStartEndDateForExcel`,
    GetBonusPoolCommissionListByStartEndDateGroup: `${apiURL}api/StoreProcedureHistory/GetBonusPoolCommissionListByStartEndDateGroup`,
    GetBoniusPoolCommissionListByStartEndDateForExcel: `${apiURL}api/StoreProcedureHistory/GetBoniusPoolCommissionListByStartEndDateForExcel`,
    GetDirectSaleCommissionListByStartEndDateGroup: `${apiURL}api/StoreProcedureHistory/GetDirectSaleCommissionListByStartEndDateGroup`,
    GetDirectSaleCommissionListByStartEndDateForExcel: `${apiURL}api/StoreProcedureHistory/GetDirectSaleCommissionListByStartEndDateForExcel`,
    GetDualTeamBonusRankHistoryListByStartEndDateForExcel: `${apiURL}api/StoreProcedureHistory/GetDualTeamBonusRankHistoryListByStartEndDateForExcel`,
  },
  DualTeamBonus: {
    ExecuteDualTeamBonusRankAssignment: `${apiURL}api/StoreProcedureHistory/ExecuteDualTeamBonusRankAssignment`,
    ExecuteDualTeamBonusCommissionProcess: `${apiURL}api/StoreProcedureHistory/ExecuteDualTeamBonusCommissionProcess`,
    ExecuteDualTeamBonusCommissionCommitProcess: `${apiURL}api/StoreProcedureHistory/ExecuteDualTeamBonusCommissionCommitProcess`,
  },
  BonusPoolCommission: {
    ExecuteBonusPoolCommissionProcess: `${apiURL}api/StoreProcedureHistory/ExecuteBonusPoolCommissionProcess`,
    ExecuteBonusPoolCommissionCommitProcess: `${apiURL}api/StoreProcedureHistory/ExecuteBonusPoolCommissionCommitProcess`,
  },
  DirectSaleCommission: {
    ExecuteDirectSaleCommissionProcess: `${apiURL}api/StoreProcedureHistory/ExecuteDirectSaleCommissionProcess`,
    ExecuteDirectSaleCommissionCommitProcess: `${apiURL}api/StoreProcedureHistory/ExecuteDirectSaleCommissionCommitProcess`,
  },
  PanelConfiguration: {
    PanelConfigurationList: `${apiURL}api/PanelConfiguration/PanelConfigurationList`,
    GetPanelDetails: `${apiURL}api/PanelConfiguration/GetPanelDetails`,
    AlarmPanelLogList: `${apiURL}api/PanelConfiguration/AlarmPanelLogList`,
    UpdatePanelHealthStatus: `${apiURL}api/PanelConfiguration/UpdatePanelHealthStatus`,
    UpdateReportingURL: `${apiURL}api/PanelConfiguration/UpdateReportingURL`,
    UpdatePanelTimeZoneAndDateTime: `${apiURL}api/PanelConfiguration/UpdatePanelTimeZoneAndDateTime`,
  },
  CameraConfiguration: { 
    GetCameraConfigurationList: `${apiURL}api/Camera/GetCameraConfigurationList`,
    DeleteCameraConfiguration: `${apiURL}api/Camera/RemoveCamera`,
  },
  AvantGuard: {
    AvantGuardList: `${apiURL}api/AvantGuard/AvantGuardList`,
    ActiveUserLocationsWithoutAGAccountList: `${apiURL}api/AvantGuard/ActiveUserLocationsWithoutAGAccountList`,
    ActiveUserLocationsWithDeletedAGAccountList: `${apiURL}api/AvantGuard/ActiveUserLocationsWithDeletedAGAccountList`,
    CreateAndUpdateAgAccount: `${apiURL}api/AvantGuard/CreateAndUpdateAgAccount`,
  },
  Log: {
    LogList: `${apiURL}api/Log/LogList`,
    LogDetails: `${apiURL}api/Log/LogDetails`,
    LogCorrelationDetails: `${apiURL}api/Log/LogCorrelationDetails`,
  },
}

export { urlConstant as default }
